import React, { createContext, useContext, useMemo, useState } from 'react';

const HighlightContext = createContext({
  highlightGroup: null,
  setHighlightGroup: () => {},
  clearHighlightGroup: () => {}
});

export function HighlightProvider({ children }) {
  const [highlightGroup, setHighlightGroupState] = useState(null);

  const setHighlightGroup = (group) => {
    setHighlightGroupState(group ? { ...group, timestamp: Date.now() } : null);
  };

  const clearHighlightGroup = () => setHighlightGroupState(null);

  const value = useMemo(() => ({
    highlightGroup,
    setHighlightGroup,
    clearHighlightGroup
  }), [highlightGroup]);

  return (
    <HighlightContext.Provider value={value}>
      {children}
    </HighlightContext.Provider>
  );
}

export function useHighlightGroup() {
  return useContext(HighlightContext);
}




